export default {
  privat: {
    breadcrumbHome: 'Faqja kryesore',
    breadcrumbSolutions: 'Zgjidhjet',
    breadcrumbCurrent: 'Shtëpia dhe prona',
    hero: {
      eyebrow: 'Klientë privatë',
      title: 'Shtëpia juaj nën vëzhgim – e planifikuar mirë dhe e instaluar me diskrecion',
      lead: 'Qoftë shtëpi familjare, apartament apo pallat – mbrojmë privatësinë dhe pronën tuaj me sisteme kamerash të përshtatura. Pa frikësim, pa mbikëqyrje të tepruar.',
    },
    useCases: {
      title: 'Zgjidhje për shtëpinë tuaj',
      lead: 'Çdo shtëpi është e ndryshme. Shqyrtojmë hyrjet, kushtet e dritës dhe dëshirat tuaja dhe planifikojmë pikat e duhura të mbikëqyrjes.',
      items: {
        '0': { title: 'Dera e hyrjes', desc: 'Dera e hyrjes është pika më e rëndësishme e mbikëqyrjes. Planifikojmë një kamerë diskrete me rezolucion të mirë – për njohje fytyrash dhe pakosh.' },
        '1': { title: 'Hyrja dhe garazhi', desc: 'Njohja e targave, mbikëqyrja e automjeteve dhe kontrolli i hyrjes – me kamera të jashtme rezistente dhe shikim nate.' },
        '2': { title: 'Kopshti dhe tarraca', desc: 'Mbikëqyrni hyrjet e kopshtit, tarracat dhe hyrjet anësore. Kamera rezistente me kënd të gjerë për pamjen e plotë.' },
        '3': { title: 'Hyjet anësore dhe dera e bodrumit', desc: 'Shpesh të lëna pas dore, por një pikë e zakonshme hyrjeje. Kamera shtesë mbyllin hendekun e fundit.' },
        '4': { title: 'Pallatet', desc: 'Hyrja, shkallët dhe zonat e jashtme – të planifikuara me respekt për privatësinë, me maskim dhe tabela.' },
        '5': { title: 'Qasja nga telefoni', desc: 'Pamje live dhe riprodhim në telefonin tuaj – në shtëpi ose në lëvizje. Ne konfigurojmë gjithçka.' },
      },
    },
    night: {
      eyebrow: 'Shikimi i natës',
      title: 'Siguri që nuk fle',
      lead: 'Shumica e incidenteve ndodhin në errësirë. Me kamera speciale ditë/natë mbani pamjen e plotë edhe natën – bardhë e zi me infra të kuqe ose edhe me ngjyra.',
      items: {
        '0': { title: 'Shikim nate me infra të kuqe', desc: 'Imazhe të qarta edhe në errësirë të plotë – deri në 30 m rreze sipas modelit.' },
        '1': { title: 'Ngjyra natën', desc: 'Imazhe me ngjyra natën në vend të bardhë e zi – falë sensorëve Starlight shumë të ndjeshëm.' },
        '2': { title: 'Ndriçim inteligjent', desc: 'LED me dritë të bardhë te lëvizja si parandalim dhe për regjistrime me ngjyra.' },
      },
    },
    privacy: {
      eyebrow: 'Mbrojtja e të dhënave',
      title: 'Mbroni zonat private, respektoni të drejtat',
      lead: 'Në mbikëqyrjen private, mbrojtja e të dhënave është veçanërisht e rëndësishme. Që në fillim kujdesemi për:',
      list: {
        '0': 'Asnjë regjistrim i rrugëve publike apo pronave të fqinjëve',
        '1': 'Maskimi i zonave private në kamerë ose regjistrues',
        '2': 'Tabela informuese në hyrje (e rekomanduar ligjërisht)',
        '3': 'Ruajtje lokale – të dhënat tuaja mbeten tek ju',
        '4': 'Të drejtat e qasjes dhe menaxhimi i përdoruesve për pallatet',
      },
      note: 'Shënim: ligjshmëria e mbikëqyrjes me video varet nga rasti konkret. Ne ju këshillojmë, por nuk zëvendësojmë këshillën ligjore.',
    },
    cta: {
      title: 'Mbroni atë që ka rëndësi për ju',
      lead: 'Një bisedë e parë jo-detyruese ju tregon mundësitë për shtëpinë tuaj – në mënyrë transparente dhe pa presion.',
      primary: 'Rezervoni një takim konsultimi',
      secondary: 'Nisni planifikuesin e kamerave',
    },
  },
};